import { api, client } from "@/client";
import { useAuthenticationStore } from "@/stores/authentication";
import { useTypesenseStore } from "@/stores/typesense";
import { defineStore, acceptHMRUpdate  } from "pinia";
import { StorageSerializers, useStorage } from "@vueuse/core";

export const useAuditStore = defineStore("audit", {
    state: () => ({
        searchKey: null as api.KeysResponseBody | null,
        activity_type: null as api.AuditActivityEnum | null
      }),
      actions: {
          async auditLog(activity_type){
            this.$reset();
            client.audit
            .audit({
              activity:activity_type as api.AuditActivityEnum
            })
            .catch((error) => {
              return error;
            })
            .finally(() => {
            });
      
          }
      
      },
      
});
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useAuditStore, import.meta.hot));
  }